<div class="sam-form-flex-row container sam-margin-left-large">
   <div class="search-icon-container sam-form-flex-row">
      <fa-icon
         [ngClass]="isSearchable ? 'sam-center icon icon-enabled' : 'sam-center icon'"
         [icon]="searchFieldIcon"
         [fixedWidth]="true"
         (click)="toggleSearchColumn($event)"
      ></fa-icon>
      <div [ngClass]="isSearchable ? 'side-bar side-bar-enabled' : 'side-bar'"></div>
   </div>

   <div class="sam-ellipsis-on-overflow sam-form-flex-row sam-flex-auto">
      <div class="header-text">
         {{ directoryColumnInstance | directoryColumnTitle | async }}
      </div>
      <div>
         <fa-icon
            *ngIf="isDefaultCallColumn"
            class="sam-center icon icon-faded"
            [icon]="defaultDial"
            [fixedWidth]="true"
         ></fa-icon>
      </div>
   </div>
</div>
